<nav class="sidebar-nav">
    <ul id="sidebarnav">
        <!-- User Profile-->
        <li class="sidebar-item user-profile" [class.active]="showMenu === 'user'">
            
            <a class="sidebar-link waves-effect has-arrow waves-dark" href="javascript:void(0)" (click)="addExpandClass('user')"
                aria-expanded="false">
                <span><img src="./assets/images/logo-tsi-tres.png" alt="user" /></span>
                <span class="hide-menu">
                    <b>{{sessionInfo != null ? sessionInfo.sucursal : "" }}</b>
                    <br>
                    <b class="text-wrap">{{ sessionInfo != null ? sessionInfo.nombres : "" }} </b>
                </span>
            </a>
            <!-- <ul aria-expanded="false" class="collapse" [class.in]="showMenu === 'user'">
                <li><a href="javascript:void()" class="sidebar-link p-0">My Profile </a></li>
                <li><a href="javascript:void()" class="sidebar-link p-0">My Balance</a></li>
                <li><a href="javascript:void()" class="sidebar-link p-0">Inbox</a></li>
                <li><a href="javascript:void()" class="sidebar-link p-0">Account Setting</a></li>
                <li><a href="javascript:void()" class="sidebar-link p-0">Logout</a></li>
            </ul> -->
        </li>
        <!-- First level menu -->
        <li class="sidebar-item" [class.active]="showMenu === sidebarnavItem.title"
            *ngFor="let sidebarnavItem of sidebarnavItems"
            (click)="sidebarnavItem.submenu.length != 0 ? '' : handleNotify()"
            [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
            <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true"><i
                    [ngClass]="[sidebarnavItem.icon]"></i><span
                    class="hide-menu">{{sidebarnavItem.title | translate}}</span></div>
            <a class="sidebar-link waves-effect waves-dark" style="padding-bottom: 0px; padding-top: 4px; " 
                [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
                [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink;"
                (click)="addExpandClass(sidebarnavItem.title)"
                [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
                <i  [name]="sidebarnavItem.icon"  [ngClass]="[sidebarnavItem.icon]" style="font-size: 15px;"></i>
                <!-- <i-feather [name]="sidebarnavItem.icon" [ngClass]="[sidebarnavItem.icon]" style="font-size: 15px;line-height: inherit;"></i-feather>-->
                <span class="hide-menu">{{sidebarnavItem.title | translate}}
                    <span *ngIf="sidebarnavItem.label != '' "
                        [ngClass]="[sidebarnavItem.labelClass]">{{sidebarnavItem.label | translate}}</span>
                </span>
            </a>
            <!-- Second level menu -->
            <ul aria-expanded="false" class="collapse first-level" *ngIf="sidebarnavItem.submenu.length > 0"
                [ngClass]="{'in' : showMenu === sidebarnavItem.title }">
                <li class="sidebar-item" *ngFor="let sidebarnavSubItem of sidebarnavItem.submenu"
                (click)="sidebarnavSubItem.submenu.length != 0 ? '' : handleNotify()"
                    [class.active]="showSubMenu === sidebarnavSubItem.title"
                    [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'active'">
                    <a class="sidebar-link" style="padding-bottom: 0px; padding-top: 4px; "
                        [routerLink]="sidebarnavSubItem.submenu.length > 0 ? null : [sidebarnavSubItem.path]"
                        [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'"
                        [ngClass]="[sidebarnavSubItem.class]" *ngIf="!sidebarnavSubItem.extralink;"
                        (click)="addActiveClass(sidebarnavSubItem.title)">
                        <i [ngClass]="[sidebarnavSubItem.icon]" style="line-height: inherit;"></i>
                        <span class="hide-menu">{{sidebarnavSubItem.title | translate}}</span>
                    </a>
                    <a class="sidebar-link" style="padding-bottom: 0px; padding-top: 4px; " (click)="openModal(sidebarnavSubItem.modal)"
                    [routerLink]="sidebarnavSubItem.submenu.length > 0 ? null : [sidebarnavSubItem.path]"
                    [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'"
                    [ngClass]="[sidebarnavSubItem.class]" *ngIf="sidebarnavSubItem.extralink;">
                    <i [ngClass]="[sidebarnavSubItem.icon]" style="line-height: inherit;"></i>
                    <span class="hide-menu">{{sidebarnavSubItem.title | translate}}</span>
                    </a>
                    <!-- Third level menu -->
                    <ul aria-expanded="false" class="collapse Second-level" *ngIf="sidebarnavSubItem.submenu.length > 0"
                        [ngClass]="{'in' : showSubMenu === sidebarnavSubItem.title }">
                        <li class="sidebar-item" *ngFor="let sidebarnavSubsubItem of sidebarnavSubItem.submenu"
                            [routerLinkActive]="sidebarnavSubsubItem.submenu.length > 0 ? '' : 'active'" [ngClass]="[sidebarnavSubsubItem.class]">
                            <a class="sidebar-link" [routerLink]="[sidebarnavSubsubItem.path]"
                                *ngIf="!sidebarnavSubsubItem.extralink;"
                                [routerLinkActive]="sidebarnavSubsubItem.submenu.length > 0 ? '' : 'router-link-active'">
                                <i [ngClass]="[sidebarnavSubsubItem.icon]" style="line-height: inherit;"></i>
                                <span class="hide-menu">&nbsp;&nbsp;{{sidebarnavSubsubItem.title | translate}}</span>
                            </a>
                            <a class="sidebar-link" (click)="openModal(sidebarnavSubsubItem.modal)"   *ngIf="sidebarnavSubsubItem.extralink;">
                            <i [ngClass]="[sidebarnavSubsubItem.icon]" style="line-height: inherit;"></i>
                            <span class="hide-menu">&nbsp;&nbsp;{{sidebarnavSubsubItem.title | translate}}</span>
                            </a>
                        </li>
                        
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</nav>
